var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row",class:_vm.$style.root},[_c('TrafficLocationsMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }